import HeroCarousel from "./components/HeroCarousel";
import QuickLinks from "./components/QuickLinks";
import LatestNews from "./components/LatestNews";
import WorkWall from "./components/WorkWall";
import SpecialSection from "./components/SpecialSection";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="w-full">
      <h1 className="sr-only">91动漫 - 最新热门动漫资讯与精彩动漫推荐</h1>
      <HeroCarousel />
      <QuickLinks />
      <LatestNews />
      <WorkWall />
      <SpecialSection />
      <SiteIntro />
    </div>
  );
}